import { render, staticRenderFns } from "./GetLinks.vue?vue&type=template&id=57112b7f&"
import script from "./GetLinks.vue?vue&type=script&lang=js&"
export * from "./GetLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports